import React, { ReactNode } from 'react';
import { Flex, theme as antTheme } from 'antd';

type Props = {
  children: ReactNode;
  style?: React.CSSProperties;
};

const BlockHeaderValue = ({ children, style }: Props) => {
  const { token } = antTheme.useToken();

  const valueStyle: React.CSSProperties = {
    fontSize: token.fontSize,
    color: token.colorText,
    marginTop: '1rem',
    marginBottom: '2rem',
    ...style,
  };

  return (
    <div style={valueStyle}>
      <Flex justify={'center'}>{children}</Flex>
    </div>
  );
};

export default BlockHeaderValue;
